import { useEffect, useState } from 'react';
import { fetchCurrentSeason, type RetroDiffereTableInfo } from '../lib/retroDiffereApi';

const CACHE_MS = 30_000;
let cached: { pseudo: string; at: number; data: RetroDiffereTableInfo } | null = null;

export function useRetroDiffereTableInfo(pseudo: string, enabled = true): RetroDiffereTableInfo {
  const [info, setInfo] = useState<RetroDiffereTableInfo>(() => (
    cached?.pseudo === pseudo && Date.now() - cached.at < CACHE_MS
      ? cached.data
      : {
          season: null,
          dealCount: 0,
          activePlayerCount: 0,
          activePlayers: [],
          secondaryInfo: '',
        }
  ));

  useEffect(() => {
    if (!enabled || !pseudo) return;
    let cancelled = false;

    if (cached?.pseudo === pseudo && Date.now() - cached.at < CACHE_MS) {
      setInfo(cached.data);
      return;
    }

    void fetchCurrentSeason(pseudo)
      .then(data => {
        if (cancelled) return;
        const next: RetroDiffereTableInfo = data ?? {
          season: null,
          dealCount: 0,
          activePlayerCount: 0,
          activePlayers: [],
          secondaryInfo: 'Aucune saison publiée',
        };
        cached = { pseudo, at: Date.now(), data: next };
        setInfo(next);
      })
      .catch(() => {
        if (cancelled) return;
        const fallback: RetroDiffereTableInfo = {
          season: null,
          dealCount: 0,
          activePlayerCount: 0,
          activePlayers: [],
          secondaryInfo: 'Différé historique vs 3 bots RV',
        };
        setInfo(fallback);
      });

    return () => { cancelled = true; };
  }, [pseudo, enabled]);

  return info;
}
